<template>
  <div class="card__box--div" ref="modalCon">
    <div
      v-infinite-scroll="handleInfiniteOnLoad"
      class="demo-infinite-container"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="8"
    >
      <a-list
        :data-source="data"
        :split="false"
        :grid="{ gutter: 12, column: 4 }"
      >
        <a-list-item slot="renderItem" slot-scope="item" class="con__list--box">
          <a-card
            :headStyle="headStyle"
            class="templateCard"
            :style="{
              border: selectPage.id == item.id ? '1px solid #f44336' : '',
            }"
            @click="changeSelectPage(item)"
          >
            <template slot="title">
              <div class="title__span">
                <span>{{ item.title }}</span>
                <img
                  @click="showTemplateModal(item)"
                  :src="befullImg"
                  style="width: 20px; height: 20px"
                  alt=""
                />
              </div>
            </template>
            <div class="img__container--div">
              <img
                :src="
                  item.smallImg == ''
                    ? require('@/assets/templateImg.png')
                    : item.smallImg
                "
              />
            </div>
          </a-card>
        </a-list-item>
        <div v-if="loading && !busy" class="demo-loading-container">
          <a-spin />
        </div>
      </a-list>
    </div>
    <a-modal
      v-model="templateVisible"
      centered
      width="700px"
      :title="fullPage.title"
      :getContainer="getContainer"
      :footer="null"
    >
      <SampleTemplate :page="fullPage" />
    </a-modal>
  </div>
</template>
<script>
import SampleTemplate from "./SampleTemplate";
import infiniteScroll from "vue-infinite-scroll";
import componentApi from "@/request/api-manager/component.js";
const fakeDataUrl =
  "https://randomuser.me/api/?results=5&inc=name,gender,email,nat&noinfo";
export default {
  name: "TemplateCard",
  components: {
    SampleTemplate,
  },
  directives: { infiniteScroll },
  props: {
    selectProjectId: String,
    selectPage: Object,
    selectKeyWord: String,
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 12,
      fullPage: {},
      // currentPage: {},
      headStyle: {
        fontFamily: "PingFangSC-Medium",
        fontSize: "14px",
        color: "#333333",
        background: "#fff",
        padding: "5px 10px",
      },
      befullImg: require("@/assets/edit-page/befull.png"),
      imgURL: require("@/assets/templateImg.png"),
      data: [],
      loading: false,
      busy: false,
      templateVisible: false,
    };
  },
  watch: {
    selectProjectId(val) {
      this.data = [];
      this.pageNo = 1
      this.getPageList();
    },
    selectKeyWord(val) {
      this.data = [];
      this.pageNo = 1
      this.getPageList();
    },
  },
  created() {
    // this.getPageList();
    // 模拟数据
    // this.setData()
  },
  methods: {
    changeSelectPage(page) {
      if (page.id == this.selectPage.id) {
        page = {};
      }
      this.$emit("changeSelectPage", page);
    },
    getPageList() {
      if(!this.selectProjectId || this.selectProjectId == "")
        return

      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        projectId: this.selectProjectId || "",
      };
      if (this.selectKeyWord) {
        params.title = `*${this.selectKeyWord}*`;
      }
      componentApi.list(params, "createTime", "asc").then((res) => {
        console.log("res", res);
        this.data = this.data.concat(res.result.records);
        this.loading = false;
      });
    },
    handleInfiniteOnLoad() {
      const data = this.data;
      this.loading = true;
      this.pageNo++;
      this.getPageList();
    },
    /**
     * 显示模板对话框
     */
    showTemplateModal(page) {
      this.fullPage = page;
      console.log("full", this.fullPage);
      this.templateVisible = true;
    },
    /**
     * 指定modal对话框在挂载到哪个HTML
     */
    getContainer() {
      return this.$refs.modalCon;
    },
  },
};
</script>
<style scoped lang="less">
@import "./index.less";
</style>